import {TractorState} from "../../common/Constants";
import {CustomFilterFrame} from "../../components/CRUDView";
import {Button, Row} from "reactstrap";
import Col from "reactstrap/es/Col";
import ClearButton from "../../components/CRUDView/Components/ClearButton";
import {Async as AsyncSelect, components} from "react-select";
import TwoLineItemRender from "../../components/Elements/TwoLineItemRender";
import {TractorOwnerEndpoints} from "../../common/ProxyEndpoints";
import _ from "lodash";
import React from "react";
import TTLProxy from "../../common/TTLAsyncProxy";

export const ConditionMap = [
    { label: 'Active' , value: TractorState.Active },
    { label: 'Inactive' , value: TractorState.Faulted }
];

export const TRACTORS_QUERY_FILTERS = [
    {
        key: "state",
        query: "state",
        name: "Condition",
        apply: true,
        fromQuery: value => {

            if(isFinite(value))
                return Number(value);

            switch ((value || "").toLowerCase()) {
                case "active":
                    return TractorState.Active;
                case "inactive":
                    return  TractorState.Faulted;
            }
        },
        renderValue: value => {

            switch (value) {
                case TractorState.Active:
                    return "Active";
                case TractorState.Faulted:
                    return  "Inactive";
            }
        }
    },
    {
        key: 'name',
        query: "name",
        operator: '[]',
        apply: true
    },
    {
        key: 'chassis',
        query: "chassis",
        operator: '[]',
        apply: true
    },
    {
        key: 'registrationNumber',
        query: 'registration_number',
        operator: '[]',
        apply: true
    },
    {
        key: 'tractorModel',
        query: "model",
        operator: '[]',
        apply: true
    },
    {
        key: "year",
        query: "year",
        apply: true
    },
    {
        key: "owner.id",
        query: "owner_id",
        apply: true
    },
    {
        key: "tractorOwnerName",
        query: "_owner_select_name"
    }
];

export const CustomTractorsFilterView = ({ applyFilters, toggle , values , setValue , setValues , resetValues , includeOwner = true }) => {

    const proxy = TTLProxy.getInstance();
    return <CustomFilterFrame toggle={toggle}>

        <Row className="mb-1">
            <Col md={3}>

                <b>Name</b>
                <input name="name"
                       value={values['name']}
                       onChange={evt => {
                           setValue('name',evt.target.value);
                       }}
                       type="text"
                       className="form-control form-input-select"
                       placeholder="Tractor name"/>

            </Col>

            <Col md={3}>

                <b>Registration No.</b>
                <input name="registrationNumber"
                       value={values['registrationNumber']}
                       onChange={evt => {
                           setValue('registrationNumber',evt.target.value);
                       }}
                       type="text"
                       className="form-control form-input-select"
                       placeholder="Registration no."/>

            </Col>

            <Col md={3}>

                <b>Chassis</b>
                <input name="chassis"
                       value={values['chassis']}
                       onChange={evt => {
                           setValue('chassis',evt.target.value);
                       }}
                       type="text"
                       className="form-control form-input-select"
                       placeholder="Chassis number"/>

            </Col>


            <Col md={3}>

                <b>Model</b>
                <input name="tractorModel"
                       value={values['tractorModel']}
                       onChange={evt => {
                           setValue('tractorModel',evt.target.value);
                       }}
                       type="text"
                       className="form-control form-input-select"
                       placeholder="Tractor model"/>

            </Col>
        </Row>

        <Row className="mb-1">

            <Col md={3}>

                <b>Year</b>
                <input name="year"
                       value={values['year']}
                       onChange={evt => {
                           setValue('year',evt.target.value);
                       }}
                       type="text"
                       className="form-control form-input-select"
                       placeholder="Year"/>

            </Col>

            {includeOwner && <Col md={3}>

                <div className="clearfix">
                    <b className="pull-left">Tractor Owner</b>
                    <div className="pull-right">
                        <ClearButton onClick={() => setValues({
                            owner: null,
                            tractorOwnerName: null
                        })}/>
                    </div>
                </div>
                <AsyncSelect  name="owner"
                              defaultOptions
                              cacheOptions
                              placeholder="Select tractor owner..."
                              value={values['owner']}
                              onChange={value => {
                                  setValue('owner',value);
                              }}
                              components={{
                                  Option: ({ children , ...props }) => {

                                      const owner = props.data.instance;
                                      return <components.Option {...props}>

                                          <TwoLineItemRender  media={owner.media}
                                                              line1Value={owner.name}
                                                              line2Prefix="Phone"
                                                              line2Value={owner.user.phone}/>

                                      </components.Option>

                                  }
                              }}
                              loadOptions={async (value) => {

                                  try {

                                      const res = await proxy.processRequest(TractorOwnerEndpoints.getUrl(), {
                                          search: { keyword: value , method: 'inside', fields: ['name' , 'user.email', 'user.phone' ] },
                                          pagination: { page: 1 , perPage : 5 },
                                          include: [ 'media' , 'user' ]
                                      });

                                      return res.getPayload().map(t => ({ label: t.name , value: t.id  , instance: t }));
                                  }
                                  catch (e) {

                                      // failed to load query

                                  }

                              }}/>

            </Col>}

        </Row>

        <hr/>

        <div className="clearfix">

            <div className="pull-left">
                <Button onClick={() => resetValues() }><i className="fa fa-refresh"/> Reset Filters</Button>
            </div>

            <div className="pull-right">
                <Button color="green" style={{ borderRadius: 4 }} onClick={() => {

                    let _targetFilter = { };
                    Object.keys(values).forEach(k => {

                        let _v = values[k];
                        const _initialValue = _v;

                        switch (k) {
                            case "owner":
                                k = "owner.id";
                                _v = !_.isNil(_v) ? _v.instance.id : null;
                                _targetFilter['tractorOwnerName'] = _v ? _initialValue.instance.name : undefined;
                                break;
                        }

                        if(!_.isNil(_v) && _v !== ""){
                            _targetFilter[k] = _v;
                        }
                        else{
                            _targetFilter[k] = undefined;
                        }

                    });

                    applyFilters(_targetFilter);


                }}><i className="fa fa-check"/> Apply</Button>
            </div>
        </div>

    </CustomFilterFrame>
};

export function parseTractorQueryFilters(filters) {

    const getSelectOption = (entity,queryKey,filterKey) => {
        const _key = filterKey || `${entity}.id`;
        const _name = filters[queryKey || `${entity}Name`];
        return filters[_key] ? { label: _name , value: filters[_key]  , instance: { id : filters[_key] , name: _name } } : null ;
    };

    return {
        name: filters.name || '',
        chassis: filters.chassis || '',
        registrationNumber: filters.registrationNumber || '',
        tractorModel: filters.tractorModel || '',
        year: filters.year || '',
        owner: getSelectOption('owner','tractorOwnerName')
    };

}


// WEBPACK FOOTER //
// ./src/views/Tractors/TractorsCommon.js